import React, { JSX } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { startCase } from "lodash";
import OPD_VISIT_TYPE from "../../../models/Opd";

interface Props {
  visitType: string | null;
  onVisitTypeChange: (type: string | null) => void;
}

function OpdVisitTypeSelector({ visitType, onVisitTypeChange }: Props): JSX.Element {
  const [value, setValue] = React.useState(visitType);

  return (
    <Autocomplete
      value={value}
      onChange={(_, newValue) => {
        setValue(newValue);
        onVisitTypeChange(newValue);
      }}
      options={Object.keys(OPD_VISIT_TYPE)}
      sx={{ width: 150 }}
      getOptionLabel={(option) => startCase(option)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Visit Type"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      )}
    />
  );
}

export default OpdVisitTypeSelector;
